import { delay, finalize } from 'rxjs';
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
import { logger } from 'src/app/utils';

export const LoaderInterceptor: HttpInterceptorFn = (req, next) => {
  logger.i('Request URL', req.url);
  // Skip the global loader for the background health-check ping.
  if (req.url === environment.healthUrl) {
    return next(req);
  }
  const loaderService = inject(LoaderService);
  loaderService.show();
  const testWidthDelay = environment.local;
  if (testWidthDelay) {
    return next(req).pipe(
      delay(2000),
      finalize(() => loaderService.hide()
    ));
  }
  return next(req).pipe(finalize(() => loaderService.hide()));
}
